import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ConfigService} from 'app/core/services/config.service';
import {RequestService} from 'app/core/services/request.service';
import {Http} from '@angular/http';

@Injectable()
export class SurchargesService {

    constructor(
        private configService: ConfigService,
        private requestService: RequestService,
        private http: Http
    ) {}

    getAllCurrencies() {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.currencyList.api;
        return this.requestService.get(url).map(response => response.data);
    }

    getSurchargeSchema() {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.surcharges.schema.api;
        return this.requestService.get(url).map(response => response.data);
    }

    getConfigListByKey(configKey):  Observable<any> {
        let url = this.configService.get('server').url
            + this.configService.get('endpoints').agora.surcharges.configurationListBy.api + '/' + configKey + '?sortByOrder=true';
        return this.requestService.get(url);
    }

    getDictionaryByType(dictionaryType: string) {
        let url = this.configService.get('server').url
            + this.configService.get('endpoints').agora.surcharges.dictionaryByType.api + '/' + dictionaryType + '?sortByOrder=true';
        return this.requestService.get(url).map(response => {
            let result = {};
            response.data.map((_) => {
                result[_.key] = _.value
            });
            return result;
        });
    }

    fetchAllSurchargesAPI() {
        return this.configService.get('server').url + this.configService.get('endpoints').agora.surcharges.list.api;
    }

    fetchSurchargeDetails(id: string) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.surcharges.details.api + '/' + id;
        return this.requestService.get(url).map(response => response.data);
    }

    saveSurcharge(surcharge: any):  Observable<any> {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.surcharges.add.api;
        return this.requestService.post(url, surcharge);
    }

    editSurcharge(surcharge: any):  Observable<any> {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.surcharges.edit.api;
        return this.requestService.post(url, surcharge);
    }

    deleteSurcharge(surcharge: any):  Observable<any> {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.surcharges.delete.api;
        return this.requestService.post(url, surcharge);
    }

    getProductExamFulfillmentDict(): Observable<any> {
        let url = this.configService.get('server').url + '/api/product/exam/fulfilment'; // Dummy API
        return this.requestService.get(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/surcharges/surcharges.service.ts